import { render, staticRenderFns } from "./CaptchaTurnstile.vue?vue&type=template&id=b2a7e890&scoped=true&"
import script from "./CaptchaTurnstile.vue?vue&type=script&lang=js&"
export * from "./CaptchaTurnstile.vue?vue&type=script&lang=js&"
import style0 from "./CaptchaTurnstile.vue?vue&type=style&index=0&id=b2a7e890&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a7e890",
  null
  
)

export default component.exports